// src/components/admin/page-management/section-forms/GalleryForm.js
import React from 'react';
import ImageUploader from '../ImageUploader';

const GalleryForm = ({ content, updateContent, pageSlug }) => {
  const addImage = () => {
    const images = content?.images || [];
    const newImages = [
      ...images,
      { url: '', alt: '', caption: '' }
    ];
    updateContent('images', newImages);
  };
  
  const updateImage = (index, field, value) => {
    const images = [...(content?.images || [])];
    if (!images[index]) return;
    
    images[index] = {
      ...images[index],
      [field]: value
    };
    
    updateContent('images', images);
  };
  
  const removeImage = (index) => {
    const images = [...(content?.images || [])];
    images.splice(index, 1);
    updateContent('images', images);
  };
  
  return (
    <div>
      <h3 className="font-bold text-lg mb-4">Gallery Section</h3>
      
      <div className="mb-4">
        {(content?.images || []).map((image, index) => (
          <div key={index} className="mb-4 p-3 border rounded">
            <div className="flex justify-between items-center mb-2">
              <h4 className="font-medium">Image {index + 1}</h4>
              <button
                type="button"
                className="text-red-500 hover:text-red-700"
                onClick={() => removeImage(index)}
              >
                Remove
              </button>
            </div>
            
            <div className="mb-2">
              <label className="block text-sm mb-1">Image URL</label>
              <input
                type="text"
                className="w-full p-2 border rounded"
                value={image.url || ''}
                onChange={(e) => updateImage(index, 'url', e.target.value)}
              />
              <ImageUploader 
                onImageUpload={(path) => updateImage(index, 'url', path)} 
                pageSlug={pageSlug} 
              />
            </div>
            
            <div className="mb-2">
              <label className="block text-sm mb-1">Alt Text</label>
              <input
                type="text"
                className="w-full p-2 border rounded"
                value={image.alt || ''}
                onChange={(e) => updateImage(index, 'alt', e.target.value)}
              />
            </div>
            
            <div className="mb-2">
              <label className="block text-sm mb-1">Caption</label>
              <input
                type="text"
                className="w-full p-2 border rounded"
                value={image.caption || ''}
                onChange={(e) => updateImage(index, 'caption', e.target.value)}
              />
            </div>

            {image.url && (
              <div className="mt-2 p-2 border rounded">
                <img 
                  src={image.url} 
                  alt={image.alt || `Gallery image ${index + 1}`}
                  className="max-w-full h-auto max-h-32 mx-auto"
                />
              </div>
            )}
          </div>
        ))}
        
        <button
          type="button"
          className="w-full p-2 border border-dashed rounded text-blue-500 hover:bg-blue-50"
          onClick={addImage}
        >
          + Add Image
        </button>
      </div>
    </div>
  );
};

export default GalleryForm;

